// Sidebar entries owned by the Employee module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { employeePaths } from './paths'

export const employeeNav = {
    manage: {
        title: 'employee:sidebar_employee_manage',
        path: employeePaths.employeesManage,
        rsname: resources.employees,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
